import { Routes } from '@angular/router';
import { UnsupportedVersionGuard } from '@zaoblako/web/core/guards/unsupported-version.guard';
import { AuthLayoutComponent } from '@zaoblako/web/modules/security/components/auth-layout/auth-layout.component';
import { CommonLayoutComponent } from '@zaoblako/web/shared/layouts/common.layout.component';
import { ExternalUserLayoutComponent } from '@zaoblako/web/shared/layouts/external-user-layout/external-user-layout.component';

export const CoreRoutes: Routes = [
  {
    path: '',
    component: CommonLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('../modules/dashboard/dashboard.router').then((r) => r.dashboardRouter)
      },
      {
        path: 'user',
        loadChildren: () => import('../modules/security/security.router').then((r) => r.securityRouter)
      },
      {
        path: 'client',
        loadChildren: () => import('../modules/client/client.router').then((r) => r.clientRouter)
      },
      {
        path: 'company',
        loadChildren: () => import('../modules/company/company.router').then((r) => r.companyRouter)
      },
      {
        path: 'directory',
        loadChildren: () => import('../modules/directory/directory.router').then((r) => r.directoryRouter)
      },
      {
        path: 'payments',
        loadChildren: () => import('../modules/payments/payments.router').then((r) => r.paymentsRouter)
      },
      {
        path: 'deal',
        loadChildren: () => import('../modules/deal/deal.router').then((r) => r.dealRouter)
      },
      {
        path: 'notification',
        loadChildren: () => import('../modules/activity/activity.router').then((r) => r.activityRouter)
      },
      {
        path: 'document',
        loadChildren: () => import('../modules/document/document.router').then((r) => r.documentRouter)
      },
      {
        path: 'project',
        loadChildren: () => import('../modules/project/project.router').then((r) => r.projectRouter)
      },
      {
        path: 'budget',
        loadChildren: () => import('@zaoblako/web/modules/budget/budget.router').then((r) => r.budgetRouter)
      },
      {
        path: 'debts',
        loadChildren: () => import('../modules/debts/debts.router').then((r) => r.debtsRouter)
      },
      {
        path: 'helpdesk',
        loadChildren: () => import('../modules/help-desk/help-desk.router').then((r) => r.helpDeskRouter)
      },
      {
        path: 'purchase',
        loadChildren: () => import('@zaoblako/web/modules/purchase/purchase.router').then((r) => r.purchaseRouter)
      },
      {
        path: 'ofd',
        loadChildren: () => import('@zaoblako/web/modules/ofd/ofd.router').then((r) => r.ofdRouter)
      },
      {
        path: 'control',
        loadChildren: () => import('@zaoblako/web/modules/control/control.router').then((r) => r.controlRouter)
      },
      {
        path: 'traffic',
        loadChildren: () => import('@zaoblako/web/modules/traffic/traffic.router').then((r) => r.trafficRouter)
      },
      {
        path: 'passage',
        loadChildren: () => import('@zaoblako/web/modules/passage/passage.router').then((r) => r.passageRouter)
      },
      {
        path: 'admin',
        loadChildren: () => import('@zaoblako/web/modules/admin/admin.router').then((r) => r.adminRouter)
      },
      {
        path: 'documentation',
        redirectTo: 'ai/course',
        pathMatch: 'full'
      },
      {
        path: 'ai',
        loadChildren: () =>
          import('@zaoblako/web/modules/documentation/documentation.router').then((r) => r.documentationRouter)
      }
    ]
  },
  {
    path: 'lk/external-user',
    component: ExternalUserLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../modules/lk/external-user/lk-external-user.router').then((r) => r.lkExternalUserRouter)
      }
    ]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [UnsupportedVersionGuard],
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('../modules/security/components/login/login.component').then((c) => c.LoginComponent),
        title: 'Авторизация'
      },
      {
        path: 'register',
        loadComponent: () =>
          import('../modules/security/components/register/register.component').then((c) => c.RegisterComponent),
        title: 'Регистрация'
      },
      {
        path: 'register-by-inn',
        loadComponent: () =>
          import('../modules/security/components/register-by-inn/register-by-inn.component').then(
            (c) => c.RegisterByInnComponent
          ),
        title: 'Регистрация по ИНН'
      }
    ]
  },
  {
    path: 'authentication',
    loadComponent: () =>
      import('../modules/security/components/authentication/authentication.component').then(
        (c) => c.AuthenticationComponent
      ),
    title: 'Аутентификация'
  },
  {
    path: 'first-entrance',
    canActivate: [UnsupportedVersionGuard],
    loadComponent: () =>
      import('../modules/security/components/first-entrance/first-entrance.component').then(
        (c) => c.FirstEntranceComponent
      ),
    title: 'Первый вход'
  },
  {
    path: 'license',
    loadComponent: () =>
      import('../modules/security/components/license/license.component').then((c) => c.LicenseComponent),
    title: 'Пользовательское соглашение'
  },
  {
    path: 'notfound',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
    title: 'Ошибка'
  },
  {
    path: 'unsupported-version',
    loadComponent: () =>
      import('./components/unsupported-version-page/unsupported-version-page.component').then(
        (c) => c.UnsupportedVersionPageComponent
      ),
    title: 'Неподдерживаемая версия'
  },
  {
    path: '**',
    loadComponent: () =>
      import('./components/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
    title: 'Ошибка'
  }
];
